import * as React from 'react';
import { usePublicationSectionAnalytics } from '../../hooks';
import { useDeviceCondition } from '../../../../hooks';
import { Header2, Header3 } from '@cian/ui-kit';
import { Layout } from '../../../ServicePickerWidget/Layout';

interface IPublicationLayoutProps {
  content: React.ReactNode;
}

export const PublicationLayout = ({ content }: IPublicationLayoutProps) => {
  usePublicationSectionAnalytics();

  const Header = useDeviceCondition(Header2, Header3);

  return (
    <Layout>
      <Layout.Title>
        <Header data-testid="publication-title">Публикация объявления</Header>
      </Layout.Title>
      <Layout.Content>{content}</Layout.Content>
    </Layout>
  );
};
